import { render, staticRenderFns } from "./build.vue?vue&type=template&id=ece90d4e&"
import script from "./build.vue?vue&type=script&lang=js&"
export * from "./build.vue?vue&type=script&lang=js&"
import style0 from "./build.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./build.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports